import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "index-sidebar mx-4" }
const _hoisted_2 = {
  key: 0,
  class: "user-info py-6"
}
const _hoisted_3 = { class: "d-flex justify-center my-3" }
const _hoisted_4 = { class: "text-md-h6 font-weight-bold d-flex justify-center text-white" }
const _hoisted_5 = { class: "text-sm d-flex justify-center text-white" }

import {user} from "@/api";
import {onMounted, ref} from "vue";
import store from "@/store";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBar',
  setup(__props) {

const router = useRouter()
const selected = ref<[number]>([0])

const info = ref<ReturnType<typeof user.GetUserInfo> | null>(null)

onMounted(() => {
  info.value = user.GetUserInfo()
  if (!info.value) {
    store.dispatch('snackBarModule/showError', '请先登录')
    router.push({ path: '/login' })
  }
})

const items = [
  { text: '班级管理', icon: 'mdi-clock', value: 0, path: '/' },
  { text: '游戏管理', icon: 'mdi-flag', value: 1, path: '/game' },
  { text: '用户设置', icon: 'mdi-account', value: 2, path: '/user' },
]

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_sheet, {
      class: "sidebar-container",
      height: "800px",
      "min-width": "240px"
    }, {
      default: _withCtx(() => [
        (info.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_avatar, {
                  size: "110",
                  image: info.value.avatar
                }, null, 8, ["image"])
              ]),
              _createElementVNode("div", _hoisted_4, _toDisplayString(info.value.nickname), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(info.value.username), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_divider, {
          color: "white",
          thickness: "1px",
          opacity: "0.6"
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_v_list, {
            class: "navigation-buttons",
            selected: selected.value,
            "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
            mandatory: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item, i) => {
                return _createVNode(_component_v_list_item, {
                  "base-color": "white",
                  key: i,
                  value: item.value,
                  height: "50px",
                  onClick: ($event: any) => (_unref(router).push(item.path))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      icon: item.icon,
                      class: "ml-4"
                    }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, {
                      textContent: _toDisplayString(item.text)
                    }, null, 8, ["textContent"])
                  ]),
                  _: 2
                }, 1032, ["value", "onClick"])
              }), 64))
            ]),
            _: 1
          }, 8, ["selected"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})